import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const Drafts = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection title={t(`${LANG_BASE}.sections.drafts`)} className="grid-cols-1 lg:grid-cols-2">
        <div className="col-start-1 lg:col-start-1">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.ARRIVAL_DRAFT>
            testId="nomination-arrival-draft-input"
            name={FORM_FIELDS.ARRIVAL_DRAFT}
            type="number"
            maxDigits={8}
            decimals={3}
            label={t(`${LANG_BASE}.fields.arrival-draft`)}
            onFieldChange={updateFormData}
            required
          />
        </div>
        <div className="col-start-1 lg:col-start-2">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.DEPARTURE_DRAFT>
            testId="nomination-departure-draft-input"
            name={FORM_FIELDS.DEPARTURE_DRAFT}
            type="number"
            maxDigits={8}
            decimals={3}
            label={t(`${LANG_BASE}.fields.departure-draft`)}
            onFieldChange={updateFormData}
            required
          />
        </div>
      </FormSection>
    </FormProvider>
  );
};

export default Drafts;
